import sendRequest from "../fetch"
import Qs from 'qs'
import { cleanParams, getApi } from "@/utils";

// 登录 
export const userLogin = (params) => {
  let _params = cleanParams(params);
  return sendRequest(getApi() + "login", {
    data: _params,
    method: "POST",
  });
};
// 登录方法（手机号码+验证码）
export const phoneLogin = (params) => {
  let _params = cleanParams(params);
  return sendRequest(getApi() + "phoneLogin", {
    data: _params,
    method: "POST",
  });
};

// 用户管理 => 登出logout
export const userLoginOut = (params) => {
  let _params = cleanParams(params);
  return sendRequest(getApi() + "logout", {
    data: _params,
    method: "POST",
  });
};

// 用户管理 => 修改密码
export const changePwd = (params) => {
  let _params = cleanParams(params);
  return sendRequest(getApi() + "sys/user/changePwd", {
    data: _params,
    method: "POST",
  });
};
// 用户管理 => 获取验证码图片
export const captchaImage = (params) => {
  let _params = cleanParams(params);
  return sendRequest(getApi() + "captchaImage", {
    data: _params,
    method: "GET",
  });
};
// 用户管理 => 获取用户信息
export const getUserInfo = (params) => {
  let _params = cleanParams(params);
  return sendRequest(getApi() + `getInfo`, {
    data: _params,
    method: "GET",
  });
};

// 用户管理 => 获取路由信息
export const switchSystem = (params) => {
  let _params = cleanParams(params);
  return sendRequest(getApi() + "switchSystem/login", {
    data: Qs.stringify(params),
    method: "POST",
  });
};
// 用户管理 => 首次登录点击我已知晓调用
export const agreePrivacy = (params) => {
  let _params = cleanParams(params);
  return sendRequest(getApi() + `agreePrivacy`, {
    data: _params,
    method: "POST",
  });
};
// 用户管理 => 发送登录验证码
export const loginVerifyCode = (params) => {
  let _params = cleanParams(params);
  return sendRequest(getApi() + `common/loginVerifyCode`, {
    data: _params,
    method: "GET", 
  });
};

// 发送登录验证码--根据用户名获取手机号码
export const loginCodeVerifyCode = (params) => {
  let _params = cleanParams(params);
  return sendRequest(getApi() + `common/user/loginVerifyCode`, {
    data: _params,
    method: "GET",
  });
};
// 用户管理 => 发送绑定手机号码短信验证码
export const bindPhoneCode = (params) => {
  let _params = cleanParams(params);
  return sendRequest(getApi() + `common/bindPhoneCode`, {
    data: _params,
    method: "GET", 
  });
};
// 用户管理 => 更改手机号码
export const updatePhone = (params) => {
  let _params = cleanParams(params);
  return sendRequest(getApi() + `updatePhone`, {
    data: Qs.stringify(_params),
    method: "POST", 
  });
};
// 用户管理 => 切换角色（身份）
export const switchRole = (params) => {
         let _params = cleanParams(params);
         return sendRequest(getApi() + `switchRole`, {
           data: Qs.stringify(_params),
           method: "POST",
         });
       };

// 用户管理 => 发送忘记密码短信验证码
export const forgetPasswordCode = (params) => {
  let _params = cleanParams(params);
  return sendRequest(getApi() + `common/forgetPasswordCode`, {
    data: _params,
    method: "GET",
  });
};
// 用户管理 => 忘记密码,重新设置密码
export const setForgetPassword = (params) => {
  let _params = cleanParams(params);
  return sendRequest(getApi() + "forgetPassword", {
    data: _params,
    method: "POST",
  });
};



// WEBPACK FOOTER //
// ./src/fetch/api/login.js